import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import {
  FirebaseMessaging,
  GetTokenOptions,
} from '@capacitor-firebase/messaging';
import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  options: GetTokenOptions = {
    vapidKey: environment.firebase.vapidKey,
  };

  constructor(private router: Router) {}

  public async init() {
    try {
      this.addListeners();

      // Si richiede all'utente il permesso ad utilizzare le notifiche
      await FirebaseMessaging.requestPermissions();
      // Per ottenere il token del dispositivo web?
      if (Capacitor.getPlatform() === 'web') {
        this.options.serviceWorkerRegistration =
          await navigator.serviceWorker.register('firebase-messaging-sw.js');
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * Ottiene il token del dispositivo mobile
   */
  public async getToken() {
    return (await FirebaseMessaging.getToken(this.options)).token;
  }

  public async removeToken() {
    FirebaseMessaging.deleteToken();
  }

  private addListeners() {
    Capacitor.getPlatform() === 'web'
      ? this.addWebListeners()
      : this.addMobileListeners();
  }

  private addMobileListeners() {
    // Cosa succede quando arriva una notifica e l'app è aperta
    FirebaseMessaging.addListener('notificationReceived', (event) => {
      console.log('notificationReceived: ' + JSON.stringify(event));
    });
    // Cosa succede quando uno preme sopra la notifica
    FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
      console.log('notificationActionPerformed: ', { event });
      this.router.navigate(['/tabs/home']);
    });
  }

  private addWebListeners() {
    navigator.serviceWorker.addEventListener('message', (event: any) => {
      console.log('serviceWorker message: ', { event });
      const notification = new Notification(event.data.notification.title, {
        body: event.data.notification.body,
      });
      notification.onclick = (event) => {
        console.log('notification clicked: ', { event });
        this.router.navigate(['/tabs/home']);
      };
    });
  }
}
